import { render, staticRenderFns } from "./BedAssignment.vue?vue&type=template&id=64d49d3a&"
import script from "./BedAssignment.vue?vue&type=script&lang=js&"
export * from "./BedAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports